<div class="auth-full-height">
    <div class="row m-0">
        <div class="col p-0 auth-full-height" style="background-image: url('/assets/images/others/bg-1.jpg');">
            <div class="d-flex justify-content-between flex-column h-100 px-5 py-3">
                <div></div>
                <div class="w-100 ">
                    <h1 class="display-4 text-white mb-4">Start with Espire</h1>
                    <p class="text-white lead" style="max-width: 630px;">Climb leg rub face on everything give attitude nap all day for under the bed. Chase mice attack feet but rub face on everything hopped up.</p>
                </div>
                <div class="d-flex justify-content-between">
                    <span class="text-white">© 2021 ThemeNate</span>
                    <div>
                        <a href="" class="text-white text-link me-3">Legal</a>
                        <a href="" class="text-white text-link">Privacy</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0 auth-full-height bg-white" style="max-width: 450px;">
            <div class="d-flex h-100 align-items-center p-5">
                <div class="w-100">
                    <div class="d-flex justify-content-center mt-3">
                        <logo class="text-center"></logo>
                    </div>
                    <div class="mt-4">
                        <login-form></login-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>